"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RebaserError = exports.ParserError = exports.RetrieverError = void 0;
class RetrieverError extends Error {
    constructor(uri, originalError) {
        super(uri);
        this.uri = uri;
        this.originalError = originalError;
        this.name = 'RetrieverError';
    }
}
exports.RetrieverError = RetrieverError;
class ParserError extends Error {
    constructor(scope, type, errors) {
        super(type);
        this.scope = scope;
        this.errors = errors;
        this.name = 'ParserError';
    }
}
exports.ParserError = ParserError;
class RebaserError extends Error {
    constructor(scope, type, errors) {
        super(type);
        this.scope = scope;
        this.errors = errors;
        this.name = 'RebaserError';
    }
}
exports.RebaserError = RebaserError;
//# sourceMappingURL=errors.js.map